import React from 'react';
import { Link } from 'react-router-dom';
import { FaShieldAlt, FaLock } from 'react-icons/fa';
import { IconWrapper } from './IconWrapper';
import OptimizedImage from './OptimizedImage';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-gray-800 text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-5 gap-8 mb-8">
          <div>
            <OptimizedImage
              src="/images/logo.webp"
              alt="LiveSportifs"
              className="h-12 w-auto mb-4"
              width={57}
              height={48}
              sizes="57px"
            />
            <p className="text-gray-400 text-sm">
              Votre comparateur de confiance pour les sites de paris sportifs en France.
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/comparaison" className="text-gray-400 hover:text-white transition-colors">
                  Comparaison
                </Link>
              </li>
              <li>
                <Link to="/winamax" className="text-gray-400 hover:text-white transition-colors">
                  Winamax
                </Link>
              </li>
              <li>
                <Link to="/olybet" className="text-gray-400 hover:text-white transition-colors">
                  Olybet
                </Link>
              </li>
              <li>
                <Link to="/genybet" className="text-gray-400 hover:text-white transition-colors">
                  Genybet
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Informations</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-white transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/a-propos" className="text-gray-400 hover:text-white transition-colors">
                  À propos
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Légal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/conditions-utilisation" className="text-gray-400 hover:text-white transition-colors">
                  Conditions d'utilisation
                </Link>
              </li>
              <li>
                <Link to="/politique-confidentialite" className="text-gray-400 hover:text-white transition-colors">
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <Link to="/politique-cookies" className="text-gray-400 hover:text-white transition-colors">
                  Politique des cookies
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Sécurité</h4>
            <div className="flex items-center space-x-2 text-sm text-gray-400 mb-2">
              <IconWrapper icon={FaShieldAlt} />
              <span>Sites licenciés ANJ</span>
            </div>
            <div className="flex items-center space-x-2 text-sm text-gray-400">
              <IconWrapper icon={FaLock} />
              <span>Données sécurisées</span>
            </div>
          </div>
        </div>
        {/* Responsible Gaming Organizations */}
        <div className="border-t border-gray-700 pt-8 mb-8">
          <h4 className="font-semibold mb-4 text-center text-gray-300">Organisations de jeu responsable</h4>
          <div className="flex flex-wrap justify-center items-center gap-6">
            <a
              href="https://anj.fr/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
              aria-label="Autorité Nationale des Jeux"
            >
              <OptimizedImage
                src="/images/footer/anj.webp"
                alt="ANJ - Autorité Nationale des Jeux"
                className="h-12 w-auto object-contain"
                width={12}
                height={12}
                sizes="72px"
              />
            </a>
            <a
              href="https://www.hippodromesenfete.fr/jouons-responsable/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
              aria-label="Jouons Responsable"
            >
              <OptimizedImage
                src="/images/footer/jouns.webp"
                alt="Jouons Responsable"
                className="h-12 w-auto object-contain"
                width={72}
                height={48}
                sizes="72px"
              />
            </a>
            <a
              href="https://www.data.gouv.fr/en/organizations/autorite-de-regulation-des-jeux-en-ligne-arjel/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
              aria-label="ARJEL"
            >
              <OptimizedImage
                src="/images/footer/arjel.webp"
                alt="ARJEL - Autorité de Régulation des Jeux en Ligne"
                className="h-12 w-auto object-contain"
                width={72}
                height={48}
                sizes="72px"
              />
            </a>
            <a
              href="https://mediateurdesjeuxenligne.fr/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
              aria-label="Médiateur des Jeux en Ligne"
            >
              <OptimizedImage
                src="/images/footer/mediater.webp"
                alt="Médiateur des Jeux en Ligne"
                className="h-12 w-auto object-contain"
                width={72}
                height={48}
                sizes="72px"
              />
            </a>
            <a
              href="https://www.gambleaware.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
              aria-label="BeGambleAware"
            >
              <OptimizedImage
                src="/images/footer/begamble.webp"
                alt="BeGambleAware"
                className="h-12 w-auto object-contain"
                width={72}
                height={48}
                sizes="72px"
              />
            </a>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © {currentYear} LiveSportifs. Tous droits réservés.
            </p>
            <p className="text-gray-400 text-sm text-center">
              18+ | Jeu responsable | 
              <a 
                href="https://www.joueurs-info-service.fr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="ml-1 hover:text-white transition-colors"
              >
                Joueurs-info-service.fr
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

